import React, { useState, useEffect, useCallback } from 'react';

const QuestionCard = ({ question, allItems, onAnswer }) => {
  const [questionType, setQuestionType] = useState('');
  const [options, setOptions] = useState([]);
  const [selectedAnswer, setSelectedAnswer] = useState(null);
  const [correctAnswer, setCorrectAnswer] = useState('');
  const [isAnswered, setIsAnswered] = useState(false);

  // Shuffle array function
  const shuffleArray = (array) => {
    const shuffled = [...array];
    for (let i = shuffled.length - 1; i > 0; i--) {
      const j = Math.floor(Math.random() * (i + 1));
      [shuffled[i], shuffled[j]] = [shuffled[j], shuffled[i]];
    }
    return shuffled;
  };

  // Generate distractors
  const generateDistractors = useCallback((correctItem, allItems) => {
    const distractors = allItems.filter(item => item.name !== correctItem.name);
    const shuffledDistractors = shuffleArray(distractors);
    return shuffledDistractors.slice(0, 3);
  }, []);

  // Setup question when component mounts or question changes
  useEffect(() => {
    if (!question) return;

    // Reset state
    setSelectedAnswer(null);
    setIsAnswered(false);

    // Randomly choose question type
    const isNameQuestion = Math.random() < 0.5;
    setQuestionType(isNameQuestion ? 'name' : 'description');

    if (isNameQuestion) {
      // Show name, ask for description
      setCorrectAnswer(question.description);
      const distractors = generateDistractors(question, allItems);
      const allOptions = [
        question.description,
        ...distractors.map(item => item.description)
      ];
      setOptions(shuffleArray(allOptions));
    } else {
      // Show description, ask for name
      setCorrectAnswer(question.name);
      const distractors = generateDistractors(question, allItems);
      const allOptions = [
        question.name,
        ...distractors.map(item => item.name)
      ];
      setOptions(shuffleArray(allOptions));
    }
  }, [question, allItems, generateDistractors]);

  // Handle answer selection
  const handleAnswerClick = (answer) => {
    if (isAnswered) return;

    setSelectedAnswer(answer);
    setIsAnswered(true);
    
    const isCorrect = answer === correctAnswer;
    onAnswer(isCorrect, answer, correctAnswer);
  };

  // Get button class based on state
  const getButtonClass = (option) => {
    if (!isAnswered) return 'answer-button';
    
    let classes = 'answer-button disabled';
    
    if (option === correctAnswer) {
      classes += ' correct';
    } else if (option === selectedAnswer && option !== correctAnswer) {
      classes += ' incorrect';
    }
    
    return classes;
  };

  // Generate Google search URL
  const getSearchUrl = () => {
    return `https://google.com/search?q=${encodeURIComponent(`Red Tavern ${question.name}`)}`;
  };

  if (!question) return null;

  return (
    <div className="question-card">
      <div className="question">
        {questionType === 'name' ? (
          <>
            <strong>What is the description of:</strong>
            <br /><br />
            "{question.name}"
          </>
        ) : (
          <>
            <strong>What menu item matches this description:</strong>
            <br /><br />
            "{question.description}"
          </>
        )}
        <br /><br />
        <small className="category-hint">Category: {question.category}</small>
      </div>
      
      <div className="answers">
        {options.map((option, index) => (
          <button
            key={index}
            className={getButtonClass(option)}
            onClick={() => handleAnswerClick(option)}
            disabled={isAnswered}
          >
            {option}
          </button>
        ))}
      </div>
      
      <a 
        href={getSearchUrl()} 
        target="_blank" 
        rel="noopener noreferrer"
        className="lookup-link"
      >
        Look Up
      </a>
    </div>
  );
};

export default QuestionCard; 